import Layout from '../../internal/Layout.vue'
import EquipmentPage from './equipment.vue'
import ManageEquipment from './components/manageEquipment/ManageEquipment.vue'
import EquipmentQrCodeList from './components/EquipmentQrCodeList.vue'
import AddMultiplesEquipment from './components/addMultiplesEquipment/addMultiplesEquipment.vue'
import EditMultiplesEquipment from './components/EditMultiplesEquipment/editMultiplesEquipment.vue'

const EquipmentRoutes = {
  component: Layout,
  children: [
    {
      name: 'equipment',
      path: '/equipment',
      component: EquipmentPage,
      meta: {
        module: 'equipamentos',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresLaboratory: true,
      },
    },
    {
      name: 'newEquipment',
      path: '/newEquipment',
      component: ManageEquipment,
      meta: {
        module: 'equipamentos',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresLaboratory: true,
      },
    },
    {
      name: 'multiplesEquipment',
      path: '/multiplesEquipment',
      component: AddMultiplesEquipment,
      meta: {
        module: 'equipamentos',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresLaboratory: true,
      },
    },
    {
      name: 'editMultiplesEquipment',
      path: '/editMultiplesEquipment',
      component: EditMultiplesEquipment,
      meta: {
        module: 'equipamentos',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresLaboratory: true,
      },
    },
    {
      name: 'editEquipment',
      path: '/editEquipment/:equipmentId',
      component: ManageEquipment,
      props: true,
      meta: {
        module: 'equipamentos',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: false,
        requiresCoordSector: false,
        requiresLaboratory: true,
      },
    },
    {
      name: 'exportQrcode',
      path: '/exportQrcode',
      component: EquipmentQrCodeList,
      props: true,
      meta: {
        module: 'equipamentos',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresLaboratory: true,
      },
    },
  ],
}

export default EquipmentRoutes
